<template>
  <v-container>
    <v-row class="justify-center" v-if="logo_active">
      <img :src="src" class="logo" :style="{ width: logoSize }" />
    </v-row>
    <v-row class="justify-center" v-if="text_active">
      <h3 class="iconFont" :style="{ fontSize: textSize }">
        Automation made simple
      </h3>
    </v-row>
  </v-container>
</template>
<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "SlogenComp",
  data() {
    return {};
  },
  props: {
    negative: VueTypes.bool.def(false),
    logoSize: VueTypes.string.def("150px"),
    textSize: VueTypes.string.def("20px"),
    logoActive: VueTypes.bool.def(true),
    textActive: VueTypes.bool.def(true),
  },
  computed: {
    src() {
      return require(`@/assets/pine3_logo${this.negative ? "_white" : ""}.svg`);
    },
    text_active() {
      return this.textActive
    },
    logo_active() {
      return this.logoActive
    },
  },
});
</script>
<style scoped>
h3 {
  color: #3e96f3;
  font-weight: 100;
}
.logo {
  min-width: 50px;
  align-items: center;
}
</style>
